import React, { useEffect, useState } from "react";
import IconContentCard from "../../shared/IconContentCard";
import { BsDeviceSsd } from "react-icons/bs";
import { FaFileInvoiceDollar, FaCommentDots, FaCheckCircle, FaQuestion, FaFileContract } from "react-icons/fa";
import { MdEmergency, MdError, MdTroubleshoot } from "react-icons/md";
import { GiCardPick } from "react-icons/gi";
import { Button, Col, FloatingLabel, Form, Row} from "react-bootstrap";
import { useAuthState } from "../../../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import AnlageTicketStage from "../HwSupportTicket/AnlageTicketStage";
import InvoiceChoiceStage from "../HwSupportTicket/InvoiceChoiceStage";
import PoolrechnungTicketStage from "../HwSupportTicket/PoolrechnungTicketStage";
import LieferantTicketStage from "../HwSupportTicket/LieferantTicketStage";
import BodyTicketStage from "../HwSupportTicket/BodyTicketStage";
import SummaryTicketStage from "../HwSupportTicket/SummaryTicketStage";
import LieferantrechnungTicketStage from "../HwSupportTicket/LieferantrechnungTicketStage";

const TicketComponent = (props) => {

    // * initial variable
    const { user } = useAuthState();
    const [stage, setStage] = useState(props.stage || "default");
    const [apiError, setApiError] = useState("");
    const navigate = useNavigate();
    const {state} = useLocation();
    
    
    const ticketAboutRadios = ["Anlagen", "Rechnung (ENERGO, Lieferantenrechnung)", "Technisches Problem", "Sonstiges", "Notfall"];
    const [ticketAbout, setTicketAbout] = useState("");
    const [selectedAnlage, setSelectedAnlage] = useState(null);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);
    const [ticketBody, setTicketBody] = useState("");
    const [fileList, setFileList] = useState([]);
    const [selectedElvs, setSelectedElvs] = useState([]);
    const [invoicesState, setInvoicesState] = useState([]);



    // * effects
    
    // question about elv 
    useEffect(() => {
        if (state !== undefined && state !== null) {
            setSelectedElvs([state.object]);
            setTicketAbout('Energieliefervertrag');
            setStage("body");
        }
    }, [state])

    // stage effect
    useEffect(() => {
        if (stage === "default") {
            if (state === undefined || state === null) {
                setTicketAbout("");
                setSelectedAnlage(null);
                setSelectedInvoiceType(null);
                setSelectedInvoices(null);
                setTicketBody("");
                setFileList([]);
            }
        }
        if (stage === "anlagen") {
            setSelectedAnlage(null);
        }
        if (stage === "invoice") {
            setSelectedInvoiceType(null);
            setSelectedInvoices(null);
        }
        if (stage === "body") {
            setFileList([]);
        }
    }, [stage])



    // * GUI
    return (
        <IconContentCard
            variant={stage === 'error'? 'error' : null}
            icon={
                ticketAbout === "Energieliefervertrag" ? <FaFileContract size={50} /> :
                ticketAbout === 'Anlagen' ? <BsDeviceSsd size={50} /> :
                ticketAbout === 'Rechnung (ENERGO, Lieferantenrechnung)' ? <FaFileInvoiceDollar size={50} /> :
                ticketAbout === 'Technisches Problem' ? <MdTroubleshoot size={50} /> :
                ticketAbout === "Sonstiges" ? <FaQuestion size={50} /> :
                ticketAbout === "Notfall" ? <MdEmergency className="text-danger" size={50} /> :
                stage === 'Body' ? <FaCommentDots size={50} /> :
                stage === 'Done' ? <FaCheckCircle size={50} /> :
                stage === 'error'? <MdError size={50} /> :
                <GiCardPick size={50} />
            }
            >
            {
                stage === 'default' ?
                    <div>
                        <h5>Worum geht es bei Ihrem Anliegen?</h5>
                        <Row className="mt-4">
                            <Col xs="12" onChange={e => setTicketAbout(e.target.id)}>
                                {ticketAboutRadios.map(radio => (
                                    <Form.Check className={radio === "Notfall"? "text-danger":null} key={radio} id={radio} type="radio" label={radio} name="aboutRadioGroup" />
                                ))}
                            </Col>
                        </Row>
                        <Row className="mt-5 text-end">
                            <Col xs="12">
                                <Button onClick={() => ticketAbout === "Technisches Problem" || ticketAbout === "Notfall" || ticketAbout === "Sonstiges" ? setStage("body"):setStage(ticketAbout) } 
                                    className="btn-energo" 
                                    disabled={ticketAbout === ""}>Weiter</Button>
                            </Col>
                        </Row>
                    </div> :

                
                stage === "done" ? 
                <>
                    <h5 className="text-energo">Ticket erstellt!</h5>
                    <Row className="mt-5">
                        <Col xs="12" className="text-center">
                            <FaCheckCircle size={50} className="text-energo" /> <br /><br />
                            <p>Vielen Dank für Ihre Anfrage. Wir haben Ihr Ticket bekommen und werden uns in Kürze bei Ihnen melden.</p>
                        </Col>
                    </Row>
                    <Row className="mt-5">
                        <Col xs="12" className="text-end">
                            <Button
                                className="btn-energo"
                                onClick={() => setStage("default")}
                                style={{marginRight: "5px"}}
                                >Neues Ticket erstellen</Button>
                            <Button
                                className="btn-energo"
                                onClick={() => navigate("/dashboard/support/")}
                            >Ticketübersicht</Button>
                        </Col>
                    </Row>
                </> :

                stage === "error" ? 
                <>
                    <h5 className="text-danger">Fehler aufgetreten</h5>
                    <Row className="mt-5 text-center">
                        <Col xs="12">
                            <p>{apiError}</p>
                        </Col>
                    </Row>
                    <Row className="mt-5">
                        <Col xs="12" className="text-end">
                            <Button onClick={() => setStage('summarize')} variant="warning">Zurück</Button>
                        </Col>
                    </Row>
                </>
                :
                

                stage === "body" ? 
                    <BodyTicketStage 
                        customer
                        state={state}
                        body={setTicketBody} 
                        setFiles={setFileList} 
                        about={ticketAbout} 
                        invoice={selectedInvoiceType} 
                        setStage={setStage} /> :

                
                stage === "summarize" ? 
                    <SummaryTicketStage 
                        about={ticketAbout}
                        selectedUser={user}
                        user={user}
                        selectedElvs={selectedElvs}
                        selectedInvoices={selectedInvoices}
                        selectedInvoiceType={selectedInvoiceType}
                        selectedAnlage={selectedAnlage}
                        body={ticketBody}
                        files={fileList}
                        setStage={setStage}
                        error={setApiError}
                    />:

                stage === "Anlagen" ?
                    <AnlageTicketStage 
                        customer 
                        about={ticketAbout}
                        selectedInvoiceType={selectedInvoiceType} 
                        setSelectedAnlage={setSelectedAnlage} 
                        setStage={setStage} 
                        error={apiError} /> :

                stage === "Rechnung (ENERGO, Lieferantenrechnung)" ?
                    <InvoiceChoiceStage 
                        customer  
                        setSelectedInvoices={setSelectedInvoices} 
                        selectedInvoices={selectedInvoices}
                        setStage={setStage} 
                        error={apiError} /> :
                
                null
            }
        </IconContentCard>
    )
}

export default TicketComponent;